<template>
	<div>
		<div v-for="(file, i) in value" :key="i" class="mb-2">
			<b-avatar rounded button @click="playPauseAudio(i)" size="2rem" :src="file&&file.md5&&file.mime&&file.mime[0]=='image'&&file.url||null" :icon="file.mime&&file.mime[0]=='audio'&&(playing==i?'stop':'play')||''" class="mr-2"></b-avatar>
			<b-button size="sm" class="float-right" variant="danger" @click="removeFile(i)"><b-icon icon="x"></b-icon></b-button>
			<span v-if="file && file.md5">{{file.filename}} ({{bytesString(file.size)}}B)</span>
		</div>
		<b-form-file @change="onChange($event)" :accept="accept" multiple></b-form-file><br />
	</div>
</template>

<script>
import util from '@/util.js';

export default {
	name: 'PipiPupuMultiFile',
	data() { return {
		audio: null,
		playing: -1,
	}},
	props: {
		accept: String,
		value: Array,
	},
	beforeDestroy() {
		this.audio?.pause?.();
	},
	methods: {
		onChange($event) {
			this.audio?.pause?.();
			for(let i = 0; i < $event.target.files.length; i++) {
				let file = { filename: $event.target.files[i].name, size: $event.target.files[i].size };
				this.value.push(file);
				this.$emit('input', this.value);
				this.$api.uploadFile($event.target.files[i].name, $event.target.files[i]).then(result => {
					this.$nextTick(() => {
						this.$set(file, 'md5', result.md5);
						this.$set(file, 'mime', result.mime);
						this.$set(file, 'url', result.url);
						this.$emit('input', this.value);
					});
				}).catch(err => console.error('Could not upload file', err));
			}
		},
		removeFile(i) {
			if(i == this.playing && this.audio)
				this.audio.pause();
			this.value.splice(i, 1);
		},
		playPauseAudio(i) {
			if(this.value?.[i]?.mime?.[0] !== 'audio') return;
			if(!this.value[i].url) return;

			const onEnded = () => {
				this.playing = -1;
				clearAudio();
			};

			const onPause = () => {
				this.playing = -1;
				clearAudio();
			};

			const onCanPlayThrough = () => {
				this.audio?.play();
			};

			const clearAudio = () => {
				if(!this.audio) return;
				this.playing = -1;
				this.audio.removeEventListener('ended', onEnded);
				this.audio.removeEventListener('pause', onPause);
				this.audio.removeEventListener('canplaythrough', onCanPlayThrough);
				this.audio.pause();
				this.audio = null;
			};

			if(this.audio) {
				clearAudio();
				if(i == this.playing) return;
			}

			this.playing = i;
			this.audio = new Audio(this.value[i].url);
			this.audio.addEventListener('ended', onEnded);
			this.audio.addEventListener('pause', onPause);
			this.audio.addEventListener('canplaythrough', onCanPlayThrough);
		},
		bytesString(n) {
			return util.bytesString(n);
		},
	}
};
</script>

<style>
	.pipipupufile-preview {
		max-width: 128px;
		max-height: 128px;
	}
</style>
